module.exports = __webpack_public_path__ + "4e8b1862dba5a3b8bd328eabc2b155c5.png";